/**
 * «Extracto en dos toques»: el archivo que guardó el service worker
 * (`public/compartir-sw.js`) al compartir desde la app del banco. Vive en la
 * caché `rumbo-compartido` hasta que /compartido lo lee y lo borra.
 */
const CACHE = 'rumbo-compartido';
const CLAVE = '/compartido/archivo';

export type ArchivoCompartido = { nombre: string; datos: ArrayBuffer };

function hayCaches(): boolean {
  return typeof caches !== 'undefined';
}

/** El nombre tal como lo guarda `browser-preload` al elegir un archivo. */
export function sanearNombre(nombre: string): string {
  return (
    nombre
      .replace(/[^\p{L}\p{N}._-]+/gu, '_')
      .replace(/^\.+/, '')
      .slice(-100) || 'extracto'
  );
}

export async function hayArchivoCompartido(): Promise<boolean> {
  if (!hayCaches()) {
    return false;
  }
  try {
    const cache = await caches.open(CACHE);
    return (await cache.match(CLAVE)) != null;
  } catch {
    return false;
  }
}

/** Lee el archivo y lo borra de la caché: solo se usa una vez. */
export async function tomarArchivoCompartido(): Promise<ArchivoCompartido | null> {
  if (!hayCaches()) {
    return null;
  }
  try {
    const cache = await caches.open(CACHE);
    const respuesta = await cache.match(CLAVE);
    if (!respuesta) {
      return null;
    }
    await cache.delete(CLAVE);
    let nombre = 'extracto';
    try {
      nombre = decodeURIComponent(respuesta.headers.get('X-Nombre') ?? '');
    } catch {
      // Nombre ilegible: se queda «extracto».
    }
    return {
      nombre: sanearNombre(nombre),
      datos: await respuesta.arrayBuffer(),
    };
  } catch {
    return null;
  }
}
